import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import ApiService from 'helpers/apiService'; // ApiService import
import { v4 as uuidv4 } from 'uuid'; // For generating unique requestId

const ForgetPasswordForm = () => {
  // State
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const requestId = uuidv4(); // Generate unique requestId

    try {
      // API call to reset password (pass email and requestId)
      await ApiService.resetPassword(requestId, email);

      toast.success(`An email is sent to ${email} with password reset link`, {
        theme: 'colored'
      });
    } catch (error) {
      toast.error('Error sending reset link. Please try again.', {
        theme: 'colored'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder="Email address"
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="text"
          disabled={loading} // Disable input during loading
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email || loading}>
          {loading ? 'Sending...' : 'Send reset link'}
        </Button>
      </Form.Group>

      <Link className="fs-10 text-600" to="#!">
        I can't recover my account using this page
        <span className="d-inline-block ms-1"> &rarr;</span>
      </Link>
    </Form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
